import React, { Component } from 'react'
import { connect } from 'react-redux'
import { createSelector } from 'reselect'
import { filter as fuzzaldrinFilter } from 'fuzzaldrin'
import Detail from '../components/IntegrationsCatalog/Detail'
import {
  fetchIntegrationsByWorkspaceSlug,
  fetchMetadataBySlugIfNeeded,
  fetchSources,
  setCatalogDetailSettings,
  setCurrentPageName,
  trackIntegrationsCatalogButtonClick,
  trackIntegrationsCatalogAddSourceClick,
  trackIntegrationsCatalogSourceClick
} from 'actions'
import {
  getActiveWorkspaceSlug,
  getActiveWorkspace,
  getCatalogDetailSettings,
  getCurrentUser,
  getIntegrationsByWorkspaceSlug,
  getMetadataByTypeAndSlug,
  getSourceSettingsArray,
  isLegacyWorkspace
} from 'selectors'
import { integrationsCatalogDetailPage } from 'analytics'

class IntegrationsCatalogDetailApp extends Component {
  render () {
    return React.createElement(Detail, this.props)
  }

  componentDidMount () {
    this.props.onMount()
    integrationsCatalogDetailPage()
  }
}

IntegrationsCatalogDetailApp.displayName = 'IntegrationsCatalogDetailApp'

function mapStateToProps (state, ownProps) {
  const { params } = ownProps
  const workspaceSlug = params.workspaceSlug
  const canAddSources = isUserOwnerOfActiveWorkspace(state)
  const { searchTerm } = getCatalogDetailSettings(state)
  const integration = getMetadataByTypeAndSlug(state, 'integration', params.integrationSlug).data
  const { compatibleSources, connectedSources } = getSources(state, params.integrationSlug)

  return {
    workspaceSlug,
    isLegacyWorkspace: isLegacyWorkspace(state, workspaceSlug),
    searchTerm,
    integration,
    canAddSources,
    compatibleSources,
    connectedSources
  }
}

function mapDispatchToProps (dispatch, ownProps) {
  return {
    onMount: () => {
      dispatch(setCurrentPageName('integrations-catalog'))
      dispatch(fetchMetadataBySlugIfNeeded({
        metadataType: 'integration',
        slug: ownProps.params.integrationSlug
      }))
      dispatch(fetchSources(ownProps.params.workspaceSlug))
      dispatch(fetchIntegrationsByWorkspaceSlug(ownProps.params.workspaceSlug))
    },
    onSearchChange: searchTerm => dispatch(setCatalogDetailSettings({ searchTerm })),
    onButtonClick: (integrationSlug, button) => dispatch(trackIntegrationsCatalogButtonClick(integrationSlug, button)),
    onAddSourceClick: (integrationSlug, popover) => dispatch(trackIntegrationsCatalogAddSourceClick(integrationSlug, popover)),
    onSourceClick: (integrationSlug, sourceSlug, popover) => dispatch(trackIntegrationsCatalogSourceClick(integrationSlug, sourceSlug, popover))
  }
}

// Unfortunately this selector cannot be placed inside `client/selectors/workspace`
// since that would introduce a circular dependency with `client/selectors/current-user`
const isUserOwnerOfActiveWorkspace = createSelector(
  [ getActiveWorkspace, getCurrentUser ],
  ({ owners = [] }, { id }) => owners.indexOf(id) > -1
)

const getSources = (state, integrationSlug) => {
  const workspaceSlug = getActiveWorkspaceSlug(state)
  const { searchTerm } = getCatalogDetailSettings(state)
  const { data: integrationMetadata } = getMetadataByTypeAndSlug(state, 'integration', integrationSlug) || {}
  const sourceSettings = getSourceSettingsArray(state, workspaceSlug)
  const integrations = getIntegrationsByWorkspaceSlug(state, workspaceSlug).data || []
  const connectedSourceSettingIds = integrations
    .filter(integration => integration.enabled && integration.type === integrationMetadata.name)
    .map(integration => integration.project)

  return fuzzaldrinFilter(sourceSettings, searchTerm, { key: 'name' })
    .reduce((memo, sourceSetting) => {
      const isConnected = connectedSourceSettingIds.includes(sourceSetting.id)
      if (isConnected) {
        memo.connectedSources.push(sourceSetting)
      } else {
        memo.compatibleSources.push(sourceSetting)
      }
      return memo
    }, {
      compatibleSources: [],
      connectedSources: []
    })
}

export default connect(mapStateToProps, mapDispatchToProps)(IntegrationsCatalogDetailApp)



// WEBPACK FOOTER //
// ./containers/IntegrationsCatalogDetailApp.js